import queryDate from './query-date.vue'

queryDate.install = (Vue) =>{
  Vue.component(queryDate.name,queryDate);
};

export default {
  queryDate
};



// WEBPACK FOOTER //
// ./src/components/query-date/index.js